"use client"
import { createContext, useContext } from "react"

// True while the host surface is itself in motion (the mobile sheet's
// rise/drag): policy boxes' framer layout animations must sit out — their
// 100ms position tweens chase the moving pane and the whole policy block
// visibly swims in after the rest of the panel. Desktop never provides
// this, so the status-migration animations behave as always there.
export const PolicyLayoutAnimationDisabledContext = createContext(false)

export const usePolicyLayoutAnimationDisabled = () =>
  useContext(PolicyLayoutAnimationDisabledContext)
